/**
 * Window that hosts the given element. Components rendered into a pop-out
 * window (see PopoutWindow) live in a different document, so global listeners
 * (outside-click dismissal, Escape, pointer tracking) must bind to the
 * element's own window — `window` is always the opener's.
 */
export function ownerWindowOf(node: Node | null | undefined): Window {
  return node?.ownerDocument?.defaultView ?? window;
}
